import { render, staticRenderFns } from "./MyActivities.vue?vue&type=template&id=dd624388&"
import script from "./MyActivities.vue?vue&type=script&lang=js&"
export * from "./MyActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports